const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
       
        case "CALCULATE_REQUIRED_EQUIPMENT_RETRIEVED":
            return action.data;
        default:
            return state;
    }
}
